"use client";

import Modal from "../ui/Modal";
import ContactForm from "./ContactForm";

export default function ContactModal({ isOpen, onClose, translations, title }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <ContactForm translations={translations} />
        </Modal>
    );
}
